export default __webpack_public_path__ + "static/media/image.helios-p2p.513d896f.png";